import { app } from '../app';

class ResellerCompanyResource {

    /** @ngInject */
    constructor($http) {
        this.$http = $http;
    }

    manageAnotherCompany(companyId, companyName, domainName) {
        const url = `app/rest/reseller/${companyId}/company`;
        return this.$http.post(url, {companyName,domainName}, {}).then(({data}) => data);
    }
    getCompanies(companyId) {
        const url = `app/rest/reseller/${companyId}/companies`;
        return this.$http.get(url).then(({data}) => data);
    }
    addAdministrators(resellerCompanyId,companyId,administrators) {
        const url = `app/rest/reseller/${resellerCompanyId}/company/${companyId}/administrators`;
        return this.$http.post(url, administrators, {}).then(({data}) => data);
    }
    getCompanyDetail(resellerCompanyId,companyId) {
        const url = `app/rest/reseller/${resellerCompanyId}/company/${companyId}`;
        return this.$http.get(url).then(({data}) => data);
    }

}
app.service('ResellerCompanyResource', ResellerCompanyResource);


// WEBPACK FOOTER //
// ./src/portal/rest/ResellerCompanyResource.js